import { $authHost } from '.';

// Получить список профилей болезней
export const getIllnessProfiles = async () => {
    const { data } = await $authHost.get('/illness_profiles/');
    // **Ответ (200 OK):**
    // ```json
    // [
    //   {
    //     "id": 1,
    //     "title": "ХОБЛ средней тяжести",
    //     "minSpO2": 85,
    //     "maxSpO2": 95,
    //     "minO2Flow": 1,
    //     "maxO2Flow": 5,
    //     "initialO2": 2,
    //     "flow_response_latency": 60,
    //     "flow_speed_change": 1
    //   }
    // ]
    // ```
    return data;
};

// Создать новый профиль болезни
export const createIllnessProfile = async (
    title,
    minSpO2,
    maxSpO2,
    minO2Flow,
    maxO2Flow,
    initialO2,
    flow_response_latency,
    flow_speed_change
) => {
    // **Запрос:**
    // ```json
    // {
    //   "title": "ХОБЛ средней тяжести",
    //   "minSpO2": 85,
    //   "maxSpO2": 95,
    //   "minO2Flow": 1,
    //   "maxO2Flow": 5,
    //   "initialO2": 2,
    //   "flow_response_latency": 60,
    //   "flow_speed_change": 1
    // }
    // ```
    const illnessProfile = {
        title: title,
        minSpO2: minSpO2,
        maxSpO2: maxSpO2,
        minO2Flow: minO2Flow,
        maxO2Flow: maxO2Flow,
        initialO2: initialO2,
        flow_response_latency: flow_response_latency,
        flow_speed_change: flow_speed_change,
    };
    const { data } = await $authHost.post('/illness_profiles/', illnessProfile);
    // **Ответ (201 Created):**
    // ```json
    // {
    //   "id": 1,
    //   "title": "ХОБЛ средней тяжести",
    //   "minSpO2": 85,
    //   "maxSpO2": 95,
    //   "minO2Flow": 1,
    //   "maxO2Flow": 5,
    //   "initialO2": 2,
    //   "flow_response_latency": 60,
    //   "flow_speed_change": 1
    // }
    // ```
    return data;
};

// Получить профиль болезни по ID
export const getOneIllnessProfile = async (illnessProfileId) => {
    const { data } = await $authHost.get(`/illness_profiles/${illnessProfileId}/`);
    return data;
};

// Обновить профиль болезни
export const updateIllnessProfile = async (illnessProfileId, illnessProfile) => {
    // **Запрос (PATCH):**
    // ```json
    // {
    //   "title": "ХОБЛ тяжелой степени",
    //   "minSpO2": 80,
    //   "maxSpO2": 90
    // }
    // ```
    const { data } = await $authHost.put(`/illness_profiles/${illnessProfileId}/`, illnessProfile);
    return data;
};

// Удалить профиль болезни
export const deleteIllnessProfile = async (illnessProfileId) => {
    const { data } = await $authHost.delete(`/illness_profiles/${illnessProfileId}/`);
    return data;
};

// Получить профиль болезни пациента
export const getPatientIllnessProfile = async (patientId) => {
    const { data } = await $authHost.get(`/illness_profiles/patients/${patientId}/`);
    return data;
};

